import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import { updateSFRFreezingInventory } from '../../../../api/andrologyApi';
import { setAndrologyData } from '../../../../actions/andrologyAction';
import { useDispatch } from 'react-redux';
import DeleteModal from '../../../Notifications/DeleteModal';
import { toast } from 'sonner';
import { deleteNotification } from '../../../../api/notificationsApi';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import { deleteFileApi } from '../../../../api/fileApi';
const emptyModalState = {
  open: false,
  title: '',
  body: '',
  proceedText: '',
  cancelText: '',
  onSave: null,
  onClose: null,
  needsComments: false,
};

const FreezingInventory = ({
  setIsFreezingInventory,
  selectedPatientData,
  selectedSfrIdForFreezingInventory,
  dataAnalyticsSfr,
  setDataAnalyticsSfr,
}) => {
  const [rows, setRows] = useState([
    {
      dateOfCryopreservation: '',
      numberOfVialsStored: '',
      dateOfThawing: '',
      purposeOfThawing: '',
      numberOfVialsThawed: '',
      numberOfVialsRemaining: '',
    },
  ]);

  const [freezingDurationYears, setFreezingDurationYears] = useState('');
  const [freezingDurationMonths, setFreezingDurationMonths] = useState('');
  const [comments, setComments] = useState('');
  const [dateOfExpiry, setDateOfExpiry] = useState('');
  const [originalDateOfExpiry, setOriginalDateOfExpiry] = useState('');
  const [files, setFiles] = useState([]);

  const [sfrData, setSfrData] = useState({});
  const [discard, setDiscard] = useState({
    isDiscard: false,
    discardComment: '',
  });
  const [modalOpen, setModalOpen] = useState({
    open: false,
    title: '',
    body: '',
    proceedText: '',
    cancelText: '',
    onSave: null,
    onClose: null,
    needsComments: false,
  });
  const [renew, setRenew] = useState(false);
  useEffect(() => {
    let sfr;

    if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
      sfr = dataAnalyticsSfr.data;
      setSfrData(sfr);
      console.log('sfr second', sfr);
    } else {
      sfr = selectedPatientData.patient.sfr.find(
        (item) => item.id === selectedSfrIdForFreezingInventory,
      );
      setSfrData(sfr);
    }
    console.log('sfr', sfr);
    if (sfr && sfr.freezingInventory) {
      const {
        CryopreservationDetails,
        freezingDurationYears,
        freezingDurationMonths,
        dateOfExpiry,
        comments,
        originalDateOfExpiry,
        files,
      } = sfr.freezingInventory;
      if (CryopreservationDetails && CryopreservationDetails.length > 0) {
        console.log('CryopreservationDetails', CryopreservationDetails);
        setRows(CryopreservationDetails);
      }
      if (sfr.isNotificationRemoved) {
        setDiscard({
          isDiscard: sfr.isNotificationRemoved,
          discardComment: sfr.notificationDeletionComments,
        });
      }
      if (freezingDurationYears)
        setFreezingDurationYears(freezingDurationYears);
      if (freezingDurationMonths)
        setFreezingDurationMonths(freezingDurationMonths);
      if (dateOfExpiry) setDateOfExpiry(dateOfExpiry);
      if (comments) setComments(comments);
      if (originalDateOfExpiry) setOriginalDateOfExpiry(originalDateOfExpiry);
      if (files) setFiles(files);
    }
  }, [
    selectedPatientData,
    selectedSfrIdForFreezingInventory,
    dataAnalyticsSfr,
  ]);

  const handleAddRow = () => {
    if (rows.length < 5) {
      setRows([
        ...rows,
        {
          dateOfCryopreservation: '',
          numberOfVialsStored: '',
          dateOfThawing: '',
          purposeOfThawing: '',
          numberOfVialsThawed: '',
          numberOfVialsRemaining: '',
        },
      ]);
    }
  };

  const handleUpload = async (file, patientId) => {
    if (!patientId) return toast.error('Patient not created');
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            patientId,
            'Patient',
            updateFileStatusUploaded,
            'SemenFreezingInventory',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({
                file: data,
                fileTag: 'SemenFreezingInventory',
              });

              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        toast.error('Failed to upload file');
      }
    });
  };

  const handleDeleteFile = async (file, patientId) => {
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          deleteFileApi(
            'patient',
            dataAnalyticsSfr && dataAnalyticsSfr.open
              ? dataAnalyticsSfr.data.patientId
              : selectedPatientData.patient.id,
            file.id,
          ),
          {
            loading: 'Deleting file...',
            success: (data) => {
              setUploadedFiles(null);

              return resolve(data);
            },
            error: (err) => {
              reject('Failed to delete docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        toast.error('Failed to delete file');
      }
    });
  };

  const handleDurationChange = (field, value) => {
    if (field === 'dateOfExpiry') {
      if (!dateOfExpiry || dateOfExpiry === '') {
        setOriginalDateOfExpiry(value);
      }
      setDateOfExpiry(value);
    }
    if (field === 'freezingDurationYears') {
      setFreezingDurationYears(value);
    }

    if (field === 'freezingDurationMonths') {
      setFreezingDurationMonths(value);
    }
    if (
      field === 'freezingDurationYears' ||
      field === 'freezingDurationMonths'
    ) {
      const updatedValue = value || 0;
      let years =
        field === 'freezingDurationYears'
          ? updatedValue
          : freezingDurationYears || 0;
      let months =
        field === 'freezingDurationMonths'
          ? updatedValue
          : freezingDurationYears || 0;
      years = parseInt(years, 10);
      months = parseInt(months, 10);
      const totalMonths = years * 12 + months;
      const date = new Date();
      date.setMonth(date.getMonth() + totalMonths);
      if (!dateOfExpiry || dateOfExpiry === '') {
        setOriginalDateOfExpiry(date.toISOString().split('T')[0]);
      }
      setDateOfExpiry(date.toISOString().split('T')[0]);
    }
  };

  const handleChange = (index, field, value) => {
    if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
      return;
    }
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
  };

  const dispatch = useDispatch();

  const closeFreezingInventory = () => {
    setDataAnalyticsSfr({ open: false, data: {} });
  };

  const setUploadedFiles = async (file) => {
    console.log(file);
    try {
      if (
        (selectedPatientData && !selectedPatientData.patient.id) ||
        (dataAnalyticsSfr &&
          dataAnalyticsSfr.open &&
          !dataAnalyticsSfr.data.patientId)
      ) {
        return;
      }

      const files = sfrData.freezingInventory.files || [];
      if (file) {
        files.push(file);
      }

      const data = {
        id:
          dataAnalyticsSfr && dataAnalyticsSfr.open
            ? dataAnalyticsSfr.data.id
            : selectedSfrIdForFreezingInventory,
        freezingInventory: {
          CryopreservationDetails: rows,
          freezingDurationYears,
          freezingDurationMonths,
          dateOfExpiry,
          comments,
          originalDateOfExpiry,
          files: file ? files : [],
        },
      };
      const response = await updateSFRFreezingInventory(
        dataAnalyticsSfr && dataAnalyticsSfr.open
          ? dataAnalyticsSfr.data.patientId
          : selectedPatientData.patient.id,
        data,
      );
      if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
        // closeFreezingInventory();
      } else {
        setIsFreezingInventory(false);
      }
      dispatch(setAndrologyData('refresh', true));
    } catch (e) {
      console.log('error', e);
    }
  };

  const saveFreezingInventory = async () => {
    console.log('called');
    try {
      if (
        (selectedPatientData && !selectedPatientData.patient.id) ||
        (dataAnalyticsSfr &&
          dataAnalyticsSfr.open &&
          !dataAnalyticsSfr.data.patientId)
      ) {
        return;
      }

      const data = {
        id:
          dataAnalyticsSfr && dataAnalyticsSfr.open
            ? dataAnalyticsSfr.data.id
            : selectedSfrIdForFreezingInventory,
        freezingInventory: {
          CryopreservationDetails: rows,
          freezingDurationYears,
          freezingDurationMonths,
          dateOfExpiry,
          comments,
          originalDateOfExpiry,
        },
      };
      const response = await updateSFRFreezingInventory(
        dataAnalyticsSfr && dataAnalyticsSfr.open
          ? dataAnalyticsSfr.data.patientId
          : selectedPatientData.patient.id,
        data,
      );
      if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
        closeFreezingInventory();
      } else {
        setIsFreezingInventory(false);
      }
      dispatch(setAndrologyData('refresh', true));
    } catch (e) {
      console.log('error', e);
    }
  };

  const handleDeleteInventory = (notification, deleteComment) => {
    console.log(notification, deleteComment);
    if (deleteComment === '' || deleteComment === null) {
      toast.error('Please enter a reason for deletion');
      return;
    }
    toast.promise(
      deleteNotification(
        dataAnalyticsSfr && dataAnalyticsSfr.open
          ? dataAnalyticsSfr.data.patientId
          : selectedPatientData.patient.id,
        dataAnalyticsSfr && dataAnalyticsSfr.open
          ? dataAnalyticsSfr.data.id
          : selectedSfrIdForFreezingInventory,
        'semen',
        deleteComment,
      )
        .then((response) => {
          console.log(response);
          setModalOpen({ ...emptyModalState });
        })
        .then(() => {
          if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
            closeFreezingInventory();
          } else {
            setIsFreezingInventory(false);
          }
          dispatch(setAndrologyData('refresh', true));
        }),
      {
        loading: 'Deleting notification...',
        success: 'Notification deleted successfully',
        error: 'Failed to delete notification',
      },
    );
  };
  const handleDiscardInventory = async (id, comment) => {
    try {
      if (
        (selectedPatientData && !selectedPatientData.patient.id) ||
        (dataAnalyticsSfr &&
          dataAnalyticsSfr.open &&
          !dataAnalyticsSfr.data.patientId)
      ) {
        return;
      }

      const data = {
        id:
          dataAnalyticsSfr && dataAnalyticsSfr.open
            ? dataAnalyticsSfr.data.id
            : selectedSfrIdForFreezingInventory,
        freezingInventory: {
          CryopreservationDetails: rows,
          freezingDurationYears,
          freezingDurationMonths,
          dateOfExpiry,
          comments,
          originalDateOfExpiry,
          isDiscard: true,
          discardComment: comment,
        },
      };
      const response = await updateSFRFreezingInventory(
        dataAnalyticsSfr && dataAnalyticsSfr.open
          ? dataAnalyticsSfr.data.patientId
          : selectedPatientData.patient.id,
        data,
      );
      if (dataAnalyticsSfr && dataAnalyticsSfr.open) {
        closeFreezingInventory();
      } else {
        setIsFreezingInventory(false);
      }
      dispatch(setAndrologyData('refresh', true));
    } catch (e) {
      console.log('error', e);
    }
  };

  return (
    <Container className="mt-5">
      {modalOpen.open && <DeleteModal modalOpen={modalOpen} />}
      <Typography variant="h6" gutterBottom>
        Freezing Inventory
      </Typography>
      <Paper className="p-3 mb-3">
        <TableContainer component={Paper} sx={{ padding: '2px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Cryopreservation & Thawing Details
                </TableCell>
                {rows.map((_, index) => (
                  <TableCell
                    key={index}
                    style={{ fontWeight: 'bold', padding: '6px' }}
                  >{`Sample ${index + 1}`}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[
                'dateOfCryopreservation',
                'numberOfVialsStored',
                'dateOfThawing',
                'purposeOfThawing',
                'numberOfVialsThawed',
                'numberOfVialsRemaining',
              ].map((field, fieldIndex) => (
                <TableRow key={fieldIndex}>
                  <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                    {field === 'dateOfCryopreservation' &&
                      'Date of Cryopreservation'}
                    {field === 'numberOfVialsStored' &&
                      'Number of Vials Stored'}
                    {field === 'dateOfThawing' && 'Date of Thawing'}
                    {field === 'purposeOfThawing' && 'Purpose of Thawing'}
                    {field === 'numberOfVialsThawed' &&
                      'Number of Vials Thawed'}
                    {field === 'numberOfVialsRemaining' &&
                      'Number of Vials Remaining'}
                  </TableCell>
                  {rows.map((row, index) => (
                    <TableCell key={index} style={{ padding: '6px' }}>
                      {field === 'purposeOfThawing' ? (
                        <FormControl
                          fullWidth
                          sx={{
                            '& .MuiInput-underline:before': {
                              borderBottom: 'none',
                            },
                            '& .MuiInput-underline:after': {
                              borderBottom: 'none',
                            },
                          }}
                        >
                          {/* <InputLabel>Purpose of Thawing</InputLabel> */}
                          <Select
                            className="custom-text-field"
                            value={row[field]}
                            onChange={(e) =>
                              handleChange(index, field, e.target.value)
                            }
                          >
                            <MenuItem value="IUI">IUI</MenuItem>
                            <MenuItem value="IVF">IVF</MenuItem>
                            <MenuItem value="ICSI">ICSI</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          className="custom-text-field"
                          type={field.includes('date') ? 'date' : 'number'}
                          InputLabelProps={
                            field.includes('date') ? { shrink: true } : {}
                          }
                          fullWidth
                          value={row[field]}
                          onChange={(e) =>
                            handleChange(index, field, e.target.value)
                          }
                          sx={{
                            '& .MuiInput-underline:before': {
                              borderBottom: 'none',
                            },
                            '& .MuiInput-underline:after': {
                              borderBottom: 'none',
                            },
                          }}
                        />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {dataAnalyticsSfr && dataAnalyticsSfr.open ? (
          <></>
        ) : (
          <Button
            variant="primary"
            className="mt-3"
            onClick={handleAddRow}
            disabled={rows.length >= 5}
          >
            + Add more
          </Button>
        )}
      </Paper>

      <Paper className="p-3 mb-3 mt-4">
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {renew && (
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                    Freezing Duration{' '}
                  </TableCell>
                  <TableCell style={{ padding: '6px' }}>
                    <TextField
                      className="custom-text-field"
                      type="number"
                      fullWidth
                      label="Years"
                      value={freezingDurationYears}
                      onChange={(e) =>
                        handleDurationChange(
                          'freezingDurationYears',
                          e.target.value,
                        )
                      }
                      sx={{
                        '& .MuiInput-underline:before': {
                          borderBottom: 'none',
                        },
                        '& .MuiInput-underline:after': { borderBottom: 'none' },
                      }}
                    />
                  </TableCell>
                  <TableCell style={{ padding: '6px' }}>
                    <TextField
                      className="custom-text-field"
                      type="number"
                      fullWidth
                      label="Months"
                      value={freezingDurationMonths}
                      onChange={(e) =>
                        handleDurationChange(
                          'freezingDurationMonths',
                          e.target.value,
                        )
                      }
                      sx={{
                        '& .MuiInput-underline:before': {
                          borderBottom: 'none',
                        },
                        '& .MuiInput-underline:after': { borderBottom: 'none' },
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
              {/* <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>Freezing Duration (Months)</TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                   className="custom-text-field"
                    type="number"
                    fullWidth
                   
                    value={freezingDurationMonths}
                    onChange={(e) => setFreezingDurationMonths(e.target.value)}
                    sx={{ '& .MuiInput-underline:before': { borderBottom: 'none' }, '& .MuiInput-underline:after': { borderBottom: 'none' } }}
                  />
                </TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Date of Expiry
                </TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    className="custom-text-field"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={dateOfExpiry}
                    onChange={(e) =>
                      handleDurationChange('dateOfExpiry', e.target.value)
                    }
                    sx={{
                      '& .MuiInput-underline:before': { borderBottom: 'none' },
                      '& .MuiInput-underline:after': { borderBottom: 'none' },
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Comments
                </TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    className="custom-text-field"
                    fullWidth
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    sx={{
                      '& .MuiInput-underline:before': { borderBottom: 'none' },
                      '& .MuiInput-underline:after': { borderBottom: 'none' },
                    }}
                  />
                </TableCell>
              </TableRow>
              {discard.isDiscard && (
                <TableRow>
                  <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                    Deletion Comments
                  </TableCell>
                  <TableCell style={{ padding: '6px' }}>
                    <TextField
                      className="custom-text-field"
                      fullWidth
                      disabled={true}
                      value={discard.discardComment}
                      sx={{
                        '& .MuiInput-underline:before': {
                          borderBottom: 'none',
                        },
                        '& .MuiInput-underline:after': { borderBottom: 'none' },
                      }}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {discard.isDiscard && (
        <div className="row clearfix">
          <FileUploadCard
            setFiles={setFiles}
            setUploadedFiles={setUploadedFiles}
            files={sfrData.freezingInventory.files || []}
            handleUpload={handleUpload}
            id={
              dataAnalyticsSfr && dataAnalyticsSfr.open
                ? dataAnalyticsSfr.data.patientId
                : selectedPatientData.patient.id
            }
          />
          {sfrData.freezingInventory.files &&
            sfrData.freezingInventory.files.map((uploadedFile, i) => {
              const data = uploadedFile.file;

              if (uploadedFile.fileTag !== 'SemenFreezingInventory')
                return null;
              return (
                <FileDocumentCard
                  key={i}
                  DocumentName={data.displayFileName}
                  DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                  DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                  ImageUrl={
                    data?.fileType?.includes('image')
                      ? data.presignedUrl
                      : undefined
                  }
                  handleDeleteFile={() => handleDeleteFile(data)}
                  file={data}
                  fileUniquePrefix={`patient-${
                    dataAnalyticsSfr && dataAnalyticsSfr.open
                      ? dataAnalyticsSfr.data.patientId
                      : selectedPatientData.patient.id
                  }`}
                />
              );
            })}
        </div>
      )}
      {!discard.isDiscard && (
        <>
          {' '}
          <Button
            variant="primary"
            className="mt-3 mr-3"
            disabled={renew}
            onClick={() => setRenew(true)}
          >
            Renew
          </Button>
          <Button
            variant="primary"
            className="mt-3 mr-3"
            onClick={() =>
              setModalOpen({
                open: true,
                title: 'Discard Inventory',
                body: 'Enter deletion comments',
                proceedText: 'Delete',
                cancelText: 'Cancel',
                needsComments: true,
                onSave: handleDeleteInventory,
                notification: null,
                onClose: () => {
                  setModalOpen({ ...emptyModalState });
                },
              })
            }
          >
            Discard
          </Button>
          <Button
            variant="primary"
            className="mt-3 mr-3"
            onClick={saveFreezingInventory}
            style={{ width: '120px' }}
          >
            Save
          </Button>
        </>
      )}

      {renew && (
        <Button
          variant="primary"
          className="mt-3 mr-3"
          onClick={() => setRenew(false)}
        >
          Cancel
        </Button>
      )}

      {dataAnalyticsSfr && dataAnalyticsSfr.open && (
        <Button
          variant="primary"
          className="mt-3"
          onClick={closeFreezingInventory}
          style={{ width: '120px' }}
        >
          Close
        </Button>
      )}
    </Container>
  );
};

export default FreezingInventory;
